import { render, staticRenderFns } from "./lrDataList.vue?vue&type=template&id=4ed5213a"
import script from "./lrDataList.vue?vue&type=script&lang=js"
export * from "./lrDataList.vue?vue&type=script&lang=js"
import style0 from "./lrDataList.vue?vue&type=style&index=0&id=4ed5213a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports